import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items, tone = "default" }: { items: Crumb[]; tone?: "default" | "light" }) {
  const base = tone === "light" ? "text-background-100/70" : "text-foreground-500";
  const linkClass =
    tone === "light" ? "transition-colors hover:text-accent-300" : "transition-colors hover:text-primary-600";
  const currentClass = tone === "light" ? "text-background-50" : "text-foreground-800";
  const separatorClass = tone === "light" ? "text-background-100/30" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-1.5 text-xs ${base}`}>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link to={item.to} className={linkClass}>
              {item.label}
            </Link>
          ) : (
            <span className={currentClass}>{item.label}</span>
          )}
          {index < items.length - 1 && <i className={`ri-arrow-right-s-line ${separatorClass}`} />}
        </span>
      ))}
    </nav>
  );
}